import React from "react";
// Import the styles object from the CSS Module
import styles from "./BlogPostCard.module.css";
import { Link } from "react-router-dom";

function BlogPostCard({ post }) {
  // Use the imported style names as class names
  return (
    <div className={styles.card}>
      <img src={post.imageUrl} alt={post.title} className={styles.image} />
      <div className={styles.content}>
        <h3 className={styles.title}>{post.title}</h3>
        <p className={styles.excerpt}>{post.excerpt}</p>
        <div className={styles.meta}>
          <span className={styles.author}>By: {post.author}</span>
          <span className={styles.date}>{post.date}</span>
        </div>
        <Link
          to={`/blog/${post.id}`} // The dynamic path to the full post
          className={styles.readMoreLink} // Use a class for styling the Link
        >
          Read More
        </Link>
      </div>
    </div>
  );
}

export default BlogPostCard;
